"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "negrar-di-valpolicella": {
    "55d4e454": [{
      "hkey": "ee12094c",
      "slug": "arbizzano-santa-maria",
      "name": "Arbizzano-Santa Maria",
      "primary": true,
      "skipSearch": false
    }],
    "arbizzano": [{
      "hkey": "ee12094c",
      "slug": "arbizzano-santa-maria",
      "name": "Arbizzano-Santa Maria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "238f2d3a": [{
      "hkey": "ee12094c",
      "slug": "arbizzano-santa-maria",
      "name": "Arbizzano-Santa Maria",
      "primary": true,
      "skipSearch": false
    }],
    "santa-maria": [{
      "hkey": "ee12094c",
      "slug": "arbizzano-santa-maria",
      "name": "Arbizzano-Santa Maria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "negrar-di-valpolicella"
    }]
  }
};
exports["default"] = _default;